import moment from 'moment';

const UTC_DATE = /(\d{1,2} [A-Za-z]+ \d{4}) at (\d{2}):(\d{2}) UTC/g;

// Organization billing messages are persisted with server-side UTC dates.
// Show them in the viewer's time zone for organization admin notifications.
export const isOrganizationAdminBilling = item =>
  item?.Category === 'OrganizationBilling' &&
  typeof item.ActionUrl === 'string' &&
  item.ActionUrl.startsWith('/organization/');

export const localizeBillingMessage = message => {
  if (typeof message !== 'string') return message;
  return message.replace(UTC_DATE, (match, day, hh, mm) => {
    const utc = moment.utc(`${day} ${hh}:${mm}`, 'D MMMM YYYY HH:mm', true);
    if (!utc.isValid()) return match;
    return utc.local().format('D MMMM YYYY [at] HH:mm');
  });
};

export const notificationMessage = item =>
  isOrganizationAdminBilling(item)
    ? localizeBillingMessage(item.Message)
    : item.Message;
